var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.$route.meta.layout==='control')?_c('ControlLayout'):_vm._e(),(this.$route.meta.layout==='firework')?_c('FireworkLayout'):_vm._e(),(this.$route.meta.layout==null)?_c('DefaultLayout'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }